import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_BATCH = 'LOAD_BATCH'
export const INATIVAR_ASSOCIADO = 'INATIVAR_ASSOCIADO'
export const TOGGLE_ASSOCIADO_STATUS = 'TOGGLE_ASSOCIADO_STATUS'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    associados: null,
    loading: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_BATCH] ({ commit, state }) {
    await api.listEntidade('associado').then(
      data => {
        const associados = data.map(({ cpf, cnpj, razao_social, nome, ...associado }) => ({
          ...associado,
          cpf_cnpj: cpf || cnpj,
          nome_razao_social: nome || razao_social,
        }))
        commit(SET_STATE, { associados })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch, commit, state }) {
    commit(SET_STATE, { loading: true })
    await dispatch(LOAD_BATCH)
    commit(SET_STATE, { loading: false })
  },
  async [INATIVAR_ASSOCIADO] ({ dispatch, commit, state }, associado) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir o Associado?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('associado', associado.id).then(
          result => result,
          (error) => {
            Swal.fire({
              icon: 'warning',
              title: 'Atenção!',
              html: error.message
                ? error.message
                : 'Não foi possivel excluir o Associado!',
            })
          },
        )
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'O Associado foi excluído com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2500,
        })
        dispatch(BOOTSTRAP)
      }
    })
  },
  async [TOGGLE_ASSOCIADO_STATUS] ({ dispatch, state }, associado) {
    Swal.fire({
      title: 'Atualizando o status do Associado!',
    })
    Swal.showLoading()
    api
      .salvarEntidade(associado, 'associado/status', associado.id)
      .then((response) => {
        Swal.hideLoading()
        Swal.update({
          icon: 'success',
          title: `O Associado foi ${associado.status == 1 ? 'ativado' : 'inativado'
            } com sucesso!`,
        })
      })
      .catch((err) => {
        associado.status = associado.status
        console.log(err)
        Swal.hideLoading()
        Swal.update({
          icon: 'error',
          title: `Não foi possível ${associado.status == 0 ? 'ativar' : 'inativar'
            } o Associado!`,
        })
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
